module.exports = __webpack_public_path__ + "img/measure_exit.71176b8c.png";